import React, { useEffect, useState } from 'react'
// import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';
import Barcode from "react-barcode";
// import SearchIcon from '@mui/icons-material/Search';
import ScienceIcon from '@mui/icons-material/Science';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import Spinner from 'react-bootstrap/Spinner';

function GenerateBarcde({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")
    const [newBarCodeView, setNewBarCodeView] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [recordsData, setRecordsData] = useState([]);
    const [currentData, setCurrentsData] = useState([])
    const [allLabs, setAllLabs] = useState([])
    const [validity, setValidity] = useState("10");
    const [barcodeNumber, setBarcodeNumber] = useState("");
    const [selectedBox, setSelectedBox] = useState([]);
    const [showProgress, setShowProgress] = useState(false)
    const [progressOutOf, setProgressOutOf] = useState("")
    const [progressPercentage, setProgressPercentage] = useState(0)
    const [progressStatus, setProgressStatus] = useState("active")
    const [barcodesLoading, setBarcodesLoading] = useState(true)

    const handleSelectAll = () => {
        const allButtons = document.querySelectorAll(".barCodeSelector");
        if (checkedAll) {
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = false
            }
            setCheckedAll(false)
            setSelectedBox([])

            // console.log(selectedBox)
        } else {
            let allRest = [];
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = true
                allRest.push(allButtons[i].id)
            }

            setSelectedBox(allRest)
            setCheckedAll(true)
            getAllBarcodes()

            // console.log(allRest)
        }
    }

    const getNewBarcode = async (allBarCodes, allOldBarCodes) => {

        let rex = /^([a-z0-9]{14,14})$/

        let charFirst = String.fromCharCode((Math.floor(Math.random() * 26) + 65)).toUpperCase()
        let dig1 = Math.floor(Math.random() * 9)
        let dig2 = Math.floor(Math.random() * 9)
        let dig3 = Math.floor(Math.random() * 9)
        let dig4 = Math.floor(Math.random() * 9)
        let charMid = String.fromCharCode((Math.floor(Math.random() * 26) + 65)).toUpperCase()
        let dig5 = Math.floor(Math.random() * 9)
        let dig6 = Math.floor(Math.random() * 9)
        let dig7 = Math.floor(Math.random() * 9)
        let dig8 = Math.floor(Math.random() * 9)
        let dig9 = Math.floor(Math.random() * 9)
        let dig10 = Math.floor(Math.random() * 9)
        let dig11 = Math.floor(Math.random() * 9)
        let dig12 = Math.floor(Math.random() * 9)

        let newBarcodeNumber = `${charFirst}${dig1}${dig2}${dig3}${dig4}${charMid}${dig5}${dig6}${dig7}${dig8}${dig9}${dig10}${dig11}${dig12}`;

        if (!allBarCodes.includes(newBarcodeNumber) && !allOldBarCodes.includes(newBarcodeNumber) && newBarcodeNumber.length == 14) {
            return newBarcodeNumber
        } else {
            getNewBarcode(allBarCodes, allOldBarCodes)
        }
    }

    const handleBarcodeGeneration = async (e) => {
        e.preventDefault();

        let Barcodes = [];
        let allOldBarCodes = [];

        let newGeneratedBarCodes = [];

        const getAllBarCodes = await axios.post(serverUrl + "/barcodes/find", { "code": "all" });
        if (getAllBarCodes.status == 200) {
            if (getAllBarCodes.data.length > 0) {
                getAllBarCodes.data.map((data, key) => {
                    return allOldBarCodes.push(data.code)
                })
            }
        }

        for (let i = 1; i <= barcodeNumber; i++) {
            const newBarcode = await getNewBarcode(Barcodes, allOldBarCodes);
            Barcodes.push(newBarcode)
        }

        setShowProgress(true)
        setProgressStatus("active");

        for (let i = 0; i < barcodeNumber; i++) {
            setProgressOutOf(`${i + 1} / ${barcodeNumber}`)
            setProgressPercentage(Math.floor((i + 1) / barcodeNumber * 100))
            const query = {
                "image": "",
                "code": Barcodes[i],
                "verificationCode": `${Math.floor(Math.random() * 9)}${Math.floor(Math.random() * 9)}${Math.floor(Math.random() * 9)}${Math.floor(Math.random() * 9)}${Math.floor(Math.random() * 9)}${Math.floor(Math.random() * 9)}`,
                "generatedDate": new Date().toISOString(),
                "validityYear": validity,
                "status": "new",
                "usedDate": ""
            }

            const createBar = await axios.post(serverUrl + "/barcodes/add", query);
            if (createBar.status != 200) {
                console.log(createBar.data)
                setProgressStatus("error")
            } else {
                newGeneratedBarCodes.push(query)
            }
        }

        console.log(newGeneratedBarCodes)

        setProgressStatus("success")
        updateLog({ "Name": "Barcodes Created", "Barcode Quantity": barcodeNumber, "Details": newGeneratedBarCodes })
        getAllBarcodes()
        resetAllFields();
        setNewBarCodeView(false);
    }

    const getAllBarcodes = async () => {
        const query = { code: "all" }

        const getData = await axios.post(serverUrl + "/barcodes/find", query)
        if (getData.status == 200) {
            // console.log(getData.data)
            setRecordsData(getData.data)
            setCurrentsData(getData.data)

            setBarcodesLoading(false);
        } else {
            console.log(getData.data)
            setBarcodesLoading(false);
        }
    }

    const resetAllFields = () => {
        setRecordsData([]);
        setBarcodeNumber("");
        setSelectedBox([])
    }
    const updateSelectedValues = (code) => {
        let allRest = selectedBox;

        if (allRest.includes(code)) {
            allRest = allRest.filter((oldcode) => { return oldcode !== code })
            // console.log(allRest)
        } else {
            allRest.push(code)
            console.log(allRest)
        }
        setSelectedBox(allRest);
    }


    const markStateAs = async (As) => {

        // console.log(selectedBox)

        let resultsToShow = [];

        setShowProgress(true)

        for (let i = 0; i < selectedBox.length; i++) {
            setProgressOutOf(`${i + 1} / ${selectedBox.length}`)
            setProgressPercentage(Math.floor((i + 1) / selectedBox.length * 100))

            const query = { "selectedCode": selectedBox[i], "markAs": As }

            const markNow = await axios.post(serverUrl + "/barcodes/markStatusAs", query)

            if (markNow.status !== 200) {
                setProgressStatus("error")
                console.log(markNow.data)
            } else {
                resultsToShow.push(query)
            }
        }
        setProgressStatus("success")
        updateLog({ "Name": "Barcode Status Changed", "Codes": selectedBox, "Details": resultsToShow })
        getAllBarcodes()
    }

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            // console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }
    const getAllLabs = async () => {
        const getAllLabs = await axios.post(serverUrl + "/labs/get", { code: "all" });
        if (getAllLabs.status == 200) {
            setAllLabs(getAllLabs.data);
        } else {
            console.log("No Data Found");
        }
    }
    useEffect(() => {
        setSelectedBox([])
        getAllBarcodes()
        getAllLabs()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3 d-flex gap-3 justify-content-between flex-wrap'>
                        <div className='d-flex gap-5 flex-wrap'>
                            <button className="themeButtons px-4 py-2 rounded-pill fw-bold" onClick={() => { setNewBarCodeView(true) }}>New Barcode</button>
                            <button className="btn btn-secondary px-4 py-2 rounded-pill fw-bold" onClick={(e) => { markStateAs("Market_Printing_Out") }}>Send to Market Printing</button>
                        </div>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setCurrentsData(recordsData.filter((product) => { return product.name?.includes(e.target.value) })) } else { setCurrentsData(recordsData) } }}>
                                    <option value="all">All</option>
                                    {
                                        allLabs.map((data, key) => {
                                            return <option key={key} value={data.name}>{data.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setYearFilter(e.target.value) } else { setYearFilter("all") } }}>
                                    <option value="all">All</option>
                                    <option value="10">10 Years</option>
                                    <option value="12">12 Years</option>
                                    <option value="15">15 Years</option>
                                    <option value="20">20 Years</option>
                                </select>
                            </div>
                            <CSVDownloader
                                type={Type.Button}
                                filename={'GeneratedBarcodes'}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                data={
                                    jsonToCSV(currentData.filter((data) => { return data.status === "new" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }))
                                }
                            >
                                Export to Excel
                            </CSVDownloader>
                        </div>
                    </div>
                    <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                        <span>
                            Total Records:
                        </span>
                        {
                            currentData.length > 0 ?
                                currentData.filter((data) => { return data.status === "new" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                    currentData.filter((data) => { return data.status === "new" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length
                                    :
                                    "0"
                                :
                                "0"
                        }
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='sticky-top'>
                                    <th valign='middle'><input type="checkbox" className='form-check-input' checked={checkedAll} onChange={(e) => { handleSelectAll(); }} /></th>
                                    <th valign='middle' width="1%"><span className='text-nowrap'>Barcode Image</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Barcode No.</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Generated Date</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Validity Year</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Status</span></th>
                                </tr>
                            </thead>
                            {
                                !barcodesLoading ?
                                    <tbody>
                                        {
                                            currentData.length > 0 ?
                                                currentData.filter((data) => { return data.status === "new" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                                    currentData.filter((data) => { return data.status === "new" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).map((data, key) => {

                                                        return (
                                                            <tr key={key}>
                                                                <td valign='middle'>
                                                                    <input type="checkbox" id={data.code} className='form-check-input barCodeSelector' onChange={(e) => { updateSelectedValues(data.code) }} />
                                                                </td>
                                                                <td valign='middle'>
                                                                    <Barcode
                                                                        value={data.code}
                                                                        width={2}
                                                                        height={60}
                                                                        format="CODE39"
                                                                        displayValue={true}
                                                                        fontOptions=""
                                                                        font="monospace"
                                                                        // textAlign="center"
                                                                        textPosition="bottom"
                                                                        // textMargin={2}
                                                                        fontSize={35}
                                                                        background="#ffffff"
                                                                        lineColor="#000000"
                                                                        // margin={10}
                                                                        // marginTop=""
                                                                        // marginBottom=""
                                                                        // marginLeft=""
                                                                        // marginRight=""
                                                                        id=""
                                                                        className="barcodeImages"

                                                                    />
                                                                    {/* <QRCode
                                                                size={256}
                                                                // bgColor=""
                                                                fgColor="#D87339"
                                                                level="M"
                                                                title={uuidv4()}
                                                                style={{ height: "auto", maxWidth: "60px", width: "100%" }}
                                                                value={uuidv4()}
                                                                viewBox={`0 0 256 256`}
                                                            /> */}
                                                                </td>
                                                                <td valign='middle'>{data.code}</td>
                                                                <td valign='middle'>{data.generatedDate}</td>
                                                                <td valign='middle'>{data.validityYear}</td>
                                                                <td valign='middle'>{data.status}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td valign='middle' colSpan={6}>
                                                            <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                                No Data
                                                            </div>
                                                        </td>
                                                    </tr>
                                                :
                                                <tr>
                                                    <td valign='middle' colSpan={6}>
                                                        <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                            No Data
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                    :
                                    <tbody>
                                        <tr>
                                            <td valign='middle' colSpan={6}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    <Spinner animation="border" variant="dark" size="lg" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                            }

                        </table>
                    </div>
                </div>
            </div>

            <Modal
                show={showProgress}
                onHide={() => {
                    setShowProgress(false);
                    setProgressOutOf("");
                    setProgressPercentage(0);
                    setProgressStatus("active");
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            Generating the Barcode
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col d-flex justify-content-center flex-column align-items-center">
                                <Progress
                                    type="circle"
                                    percent={progressPercentage}
                                    status={progressStatus}
                                    strokeWidth={4}
                                    width={150}
                                    style={{}}
                                    theme={{
                                        success: {
                                            symbol: '',
                                            color: 'limegreen'
                                        },
                                        active: {
                                            symbol: '',
                                            color: 'skyblue'
                                        },
                                        error: {
                                            symbol: '',
                                            color: 'red'
                                        },
                                        default: {
                                            symbol: '',
                                            color: '#fbc630'
                                        }
                                    }} />
                                <span className='themeTextColor fs-3'>
                                    {progressOutOf}
                                </span>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        {
                            progressStatus == "success" ?
                                <button className='themeButtons w-100 px-5 py-1 rounded-pill fs-5' style={{ maxWidth: "200px" }} onClick={() => { setShowProgress(false) }}>Done</button>
                                :
                                <button className='themeButtons w-100 px-5 py-1 rounded-pill fs-5' disabled style={{ maxWidth: "200px" }}>
                                    <Spinner animation="grow" variant="light" size="sm" />
                                    <Spinner animation="grow" variant="light" size="sm" />
                                    <Spinner animation="grow" variant="light" size="sm" />
                                </button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={newBarCodeView}
                onHide={() => { setNewBarCodeView(false) }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <form onSubmit={(e) => { handleBarcodeGeneration(e); setProgressStatus(true) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Create Barcode
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row mb-4">
                                <div className="col-4 d-flex align-items-center">BarCode Quantity</div>
                                <div className="col-8 d-flex align-items-center">
                                    <input type="text" required className='customFieldForDence w-100' style={{ maxWidth: "300px" }} value={barcodeNumber} onInput={(e) => { setBarcodeNumber(e.target.value) }} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 d-flex align-items-center">Validity</div>
                                <div className="col-8 d-flex align-items-center">
                                    <select name="" id="" required className='customFieldForDence' value={validity} style={{ maxWidth: "300px" }} onInput={(e) => { setValidity(e.target.value) }}>
                                        <option value="10">10 Years</option>
                                        <option value="12">12 Years</option>
                                        <option value="15">15 Years</option>
                                        <option value="20">20 Years</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100 d-flex justify-content-center'>
                            <input type="submit" value="Create Now" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default GenerateBarcde